import { Typography } from 'antd';
import { TextProps } from 'antd/es/typography/Text';
import { ReactNode } from 'react';
import styles from './icon-wrapper.module.css';

interface Props {
  textProps?: TextProps;
  children: ReactNode;
}

const IconWrapper = ({ textProps, children }: Props) => {
  return (
    <Typography.Text className={styles.icon} {...textProps}>
      {children}
    </Typography.Text>
  );
};

export default IconWrapper;
